(ns common.resource.query.product-store
  (:require [cljs-bean.core :refer [->clj ->js]]
            [common.queries :refer [invalidate-queries set-query-data]]
            [common.queries.http :as qhttp]
            [promesa.core :as p]
            [re-frame.core :as rf]))

(def entity-name "product-store-fields")

(defn add-field-mutation [{:keys [advertiser-id]}]
  #js {:mutationKey #js ["add-field" advertiser-id]
       :mutationFn (fn [field]
                     (qhttp/post (qhttp/render :api/product-store-fields {:advertiser-id advertiser-id})
                                 {:body field}))
       :onSuccess (fn []
                    (invalidate-queries {:queryKey ["product-store" advertiser-id]})
                    (rf/dispatch [:response-handler/handle-response
                                  {:entity-name entity-name
                                   :type :success
                                   :message "Successfully added field"}]))
       :onError (fn [error]
                  (rf/dispatch [:response-handler/handle-response
                                {:entity-name entity-name
                                 :type :error
                                 :message "Failed to add field"
                                 :response (->clj (:data error))}]))})

(defn edit-field-mutation [{:keys [advertiser-id]}]
  #js {:mutationKey #js ["edit-field" advertiser-id]
       :mutationFn (fn [field]
                     (qhttp/patch (qhttp/render :api/product-store-field {:advertiser-id advertiser-id
                                                                          :field-id (:id field)})
                                  {:body (select-keys field [:name :empty-string-is-undefined])}))
       :onSuccess (fn []
                    (invalidate-queries {:queryKey ["product-store" advertiser-id]})
                    (rf/dispatch [:response-handler/handle-response
                                  {:entity-name entity-name
                                   :type :success
                                   :message "Successfully updated field"}]))
       :onError (fn [error]
                  (rf/dispatch [:response-handler/handle-response
                                {:entity-name entity-name
                                 :type :error
                                 :message "Failed to update field"
                                 :response (->clj (:data error))}]))})

(defn delete-field-mutation [{:keys [advertiser-id]}]
  #js {:mutationKey #js ["delete-field" advertiser-id]
       :mutationFn (fn [field-id]
                     (qhttp/delete (qhttp/render :api/product-store-field {:advertiser-id advertiser-id
                                                                           :field-id field-id})))
       :onSuccess (fn []
                    (invalidate-queries {:queryKey ["product-store" advertiser-id]})
                    (rf/dispatch [:response-handler/handle-response
                                  {:entity-name entity-name
                                   :type :success
                                   :message "Successfully deleted field"}]))
       :onError (fn [error]
                  (rf/dispatch [:response-handler/handle-response
                                {:entity-name entity-name
                                 :type :error
                                 :message "Failed to delete field"
                                 :response (->clj (:data error))}]))})

(defn move-field-mutation [{:keys [advertiser-id]}]
  #js {:mutationKey #js ["move-field" advertiser-id]
       :mutationFn (fn [{:keys [field-id new-index old-index]}]
                     (set-query-data #js ["product-store" advertiser-id]
                                     (fn [old-data]
                                       (let [data (->clj old-data)]
                                         (->js (update data :fields (fn [fields]
                                                                      (assoc fields
                                                                             new-index (fields old-index)
                                                                             old-index (fields new-index))))))))
                     (p/do
                       (qhttp/put (qhttp/render :api/product-store-field-index {:advertiser-id advertiser-id
                                                                                :field-id field-id})
                                  {:body new-index})
                       (set-query-data ["product-store" advertiser-id]
                                       (fn [old-data]
                                         old-data))))
       :onSuccess (fn []
                    (invalidate-queries {:queryKey ["product-store" advertiser-id]})
                    (rf/dispatch [:response-handler/handle-response
                                  {:entity-name entity-name
                                   :type :success
                                   :message "Successfully moved field"}]))
       :onError (fn [error]
                  (rf/dispatch [:response-handler/handle-response
                                {:entity-name entity-name
                                 :type :error
                                 :message "Failed to move field"
                                 :response (->clj (:data error))}]))})

(defn product-store-query [{:keys [advertiser-id]}]
  #js {:queryKey #js ["product-store" advertiser-id]
       :queryFn (fn []
                  (p/catch (qhttp/get (qhttp/render :api/product-store {:advertiser-id advertiser-id}))
                           (fn [response-map]
                             (if (= (:status response-map) 404)
                               (p/do (qhttp/post (qhttp/render :api/product-stores {})
                                                 {:body {:advertiser-id advertiser-id}})
                                     (qhttp/get (qhttp/render :api/product-store {:advertiser-id advertiser-id})))
                               (p/rejected response-map)))))
       :enabled (boolean advertiser-id)})
